import { store } from 'components/Store';
import { useContext } from 'react';

const useStealthModeConditional = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;

  const validStealthModeFeatureUsers = team?.myself?.emailAddress.includes('@policymogul.com');
  return { validStealthModeFeatureUsers };
};

export default useStealthModeConditional;
